import { adminReducer } from "../reducers/adminReducer"

export const types = {

    login : '[auth] Login',
    logout : '[auth] Logout',
    recuperarLogin: '[auth] Iniciar Recuperar SessiÃ³ Login',
    recuperarLoginFinish: '[auth] Fi Recuperar SessiÃ³ Login',
    renovarToken : '[auth] Renovar Token Usuari',


    uiCrearError: '[UI] Crear Error',
    uiCrearOk: '[UI] Crear tot Ok',
    uiEsborrarOk: '[UI] Esborrar Ok',
    uiEsborrarOkError: '[UI] Esborrar Ok Eroor',
    uiEsborrarError: '[UI] Esborrar Error',
    uiIniciarCarrega: '[UI] Iniciar cÃ rrega',
    uiFinalitzarCarrega: '[UI] Finalitzar cÃ rrega',
    uiModalUser: '[UI] Obri Modal Modificar ',
    uiIniciarFormulario:'[UI] Iniciar Formulario Action',
    uiFinalitzarFormulario:'[UI] Finalitzar Formulario Action',
    uiActualizarResultats:'[UI] Actualizar Valor Resultats',
    uiActualizarResultatCat:'[UI] Mostar  Resultats categoria',
    uiActualizarTextosState:'[UI] Actualizar State Textos',
    uiActualizarIndicadoresState:'[UI] Actualizar State Indicadores',
    uiActualizarResultatsEvaluacio: '[UI] Guardar objecte Evaluacio per Resultats',

    configUsuariRecuperarInfo: '[ConfigUsuari] Iniciar recuperar InformaciÃ³ de usuari al servei',
    configUsuariRecuperarInfoFinalitzada: '[ConfigUsuari] Fi RecuperaciÃ³ InformaciÃ³ de usuari al servei',

    configAplicacioRecuperarHistoric:'[ConfigAplicacio] Recuperar Info historic d evaluacions',
    configAplicacioRecuperarHistoricPaginat: '[ConfigAplicacio] Recuperar historial admin paginat',
    configAplicacioSetCarregant: '[ConfigAplicacio] Set estat carregant',

    configFormularioInfo:'[ConfigFormulario] Iniciar Formulario',
    configFormularioCategoria:'[ConfigFormulario] Iniciar recuperar info Formulario Cat',
    configTextFormularioCategoria:'[ConfigFormulario] Iniciar recuperar info Text Formulario Cat',
    configFormularioPreguntas:'[ConfigFormulario] Cargar preguntas dinámicas del formulario',
    configConstantesFormularioCategoria:'[ConfigFormulario] Iniciar recuperar info Constantes Formulario Cat',
    configIndicadoresFormularioCategoria:'[ConfigFormulario] Iniciar recuperar info Indicadores Formulario Cat',
    configFormularioResultats:'[ConfigFormulario] Resultats categoria ',

    configActualizarTextoCategoria:'[ConfigFormulario] Config ACtualizar Texto ',
    configActualizarConstantesCategoria:'[ConfigFormulario] Config ACtualizar Constantes ',
    configActualizarIndicadoresCategoria:'[ConfigFormulario] Config ACtualizar Indicadores ',
    textosPDFRecuperarInfo: '[TextosPDF] Recuperar info',
    textosPDFActualizarTexto: '[TextosPDF] Actualizar texto',
    adminCarregarUsuaris:           '[Admin] Carregar Tots Els Usuaris',
    adminCarregarMunicipis:         '[Admin] Carregar Tots Els Municipis',
    adminCarregarUsuarisMunicipi:   '[Admin] Carregar Usuaris Municipi',
    adminCrearMunicipi:             '[Admin] Crear Municipi',

    


    
}


